import { store } from 'react-easy-state'

const _store = store({
  otp: '',
  setOtp(otp) {
    _store.otp = otp
  },
  checkCompleteOtp() {
    return _store.otp.length === 6
  }
})

export default _store
